import { Link } from "react-router-dom";
import { ArrowRight, Heart, Aperture, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { BRAND, IMAGES } from "@/data";

const VALUES = [
  { icon: Heart, title: "Emozione autentica", text: "Cerco il momento vero, non la posa costruita. Il ricordo che resta nel tempo." },
  { icon: Aperture, title: "Cura artigianale", text: "Post-produzione professionale su ogni scatto, per un risultato elegante e coerente." },
  { icon: Clock, title: "Consegne puntuali", text: "Sneak peek rapidi e consegne garantite nei tempi concordati, sempre." },
];

const ChiSiamo = () => (
  <div data-testid="chi-siamo-page" className="bg-[#0c0c0c] pt-32">
    <Seo
      title="Chi Sono | Salvatore Castelli · Fotografo a Faleria (Viterbo)"
      description="Salvatore Castelli, fotografo con base a Faleria nel cuore della Tuscia Viterbese. Reportage emozionale di matrimoni, compleanni ed eventi in tutta la Tuscia e a Roma."
      path="/chi-sono"
    />
    <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-20">
      <Reveal>
        <span className="text-sm uppercase tracking-[0.3em] text-gold">Chi Sono</span>
        <h1 className="font-serif text-4xl md:text-6xl text-white font-light mt-6 max-w-3xl leading-tight">
          Salvatore Castelli, fotografo a Faleria
        </h1>
      </Reveal>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center pb-24">
      <Reveal>
        <div className="overflow-hidden">
          <img src={IMAGES.portrait} alt="Salvatore Castelli" className="w-full h-[600px] object-cover hover:scale-105 transition-transform duration-700" />
        </div>
      </Reveal>
      <Reveal delay={150}>
        <p className="text-stone-300 leading-relaxed text-lg">
          La fotografia, per me, è un modo di fermare il tempo. Vivo e lavoro a Faleria, nel cuore
          della Tuscia Viterbese, vicino a Roma, e ho fatto della passione per l&apos;immagine il mio mestiere.
        </p>
        <p className="text-stone-400 leading-relaxed mt-5">
          Racconto matrimoni, battesimi, compleanni ed eventi aziendali con uno sguardo discreto e
          attento ai dettagli. Amo il reportage: seguo la giornata così come accade, per restituire
          emozioni sincere invece di pose rigide.
        </p>
        <p className="text-stone-400 leading-relaxed mt-5">
          Conosco a fondo il territorio della Tuscia Viterbese — da Viterbo ai borghi circostanti — e le sue location
          più suggestive. Questo mi permette di valorizzare ogni scatto con la luce e i paesaggi giusti.
        </p>
        <div className="flex flex-wrap gap-3 mt-8">
          {BRAND.areas.map((a) => (
            <span key={a} className="border border-stone-700 text-stone-300 text-xs uppercase tracking-widest px-4 py-2">
              {a}
            </span>
          ))}
        </div>
      </Reveal>
    </section>

    <section className="bg-[#0a0a0a] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        {VALUES.map((v, i) => (
          <Reveal key={i} delay={i * 120} className="border border-stone-800 bg-[#111] p-8">
            <v.icon className="text-gold mb-5" size={30} />
            <h3 className="font-serif text-xl text-white">{v.title}</h3>
            <p className="text-stone-400 text-sm mt-3 leading-relaxed">{v.text}</p>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="py-24 text-center px-6">
      <Reveal>
        <h2 className="font-serif text-3xl md:text-4xl text-white font-light">Racconto la tua storia</h2>
        <Link to="/contatti" className="inline-flex items-center gap-2 bg-gold text-[#0c0c0c] uppercase tracking-[0.15em] text-sm font-medium px-8 py-4 mt-8 hover:bg-[#b5952f] transition-colors duration-300">
          Contattami <ArrowRight size={18} />
        </Link>
      </Reveal>
    </section>
  </div>
);

export default ChiSiamo;
